// Module
var code = `<div class="job-table-popup" ng-mouseover="basePopupCtrl.onHover()" ng-mouseleave="basePopupCtrl.onLeave()"> <i class="fa {{basePopupCtrl.iconClass}}"></i> <div class="job-table-popup--content" ng-show="basePopupCtrl.showContent" ng-bind-html="basePopupCtrl.content"> </div> </div>`;
// Exports
export default code;